import { render, staticRenderFns } from "./RegistrationSummaryPage.vue?vue&type=template&id=c82bd588&scoped=true"
import script from "./RegistrationSummaryPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationSummaryPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationSummaryPage.vue?vue&type=style&index=0&id=c82bd588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82bd588",
  null
  
)

export default component.exports